

export const urlChecker = (urlOrUuid) => {
    if (typeof urlOrUuid === 'string' && urlOrUuid.startsWith('https://')) {
        return true;
    } else {
        return false;
    }
};